import { render, staticRenderFns } from "./StockPlaceProduct.vue?vue&type=template&id=e6fb8572&"
import script from "./StockPlaceProduct.vue?vue&type=script&lang=js&"
export * from "./StockPlaceProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports